import TR from 'utils/TR';
import Section from 'components/common/Section';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';
import PatternSummaryBox from './PatternSummaryBox';
import DIRECTION_HORIZONTAL from 'constants/DIRECTION_HORIZONTAL';
import useSetChartData from 'hooks/app/useSetChartData';
import useOnce from 'hooks/common/useOnce';
import useImageObj from 'hooks/common/useImageObj';

export default function GlocosePattern(props) {
  const {
    duration,
    data,
  } = props || {};
  const {
    week_days_bld_sugr_mbti = '',
    weekend_bld_sugr_mbti = '',
    week_days_bld_sugr_mbti_content = '',
    weekend_bld_sugr_mbti_content = '',
    week_days_dawn_pattern_info,
    week_days_morning_pattern_info = '',
    week_days_lunch_pattern_info = '',
    week_days_evening_pattern_info = '',
    weekend_dawn_pattern_info = '',
    weekend_morning_pattern_info = '',
    weekend_lunch_pattern_info = '',
    weekend_evening_pattern_info = '',
    week_days_bld_sugr_mbti_image_url,
    weekend_bld_sugr_mbti_image_url,
  } = data || {};

  const setWeekdayData = useSetChartData('GlocosePatternWeekdayChart');
  const setWeekendData = useSetChartData('GlocosePatternWeekendChart');

  const weekday_image = useImageObj(week_days_bld_sugr_mbti_image_url);
  const weekend_image = useImageObj(weekend_bld_sugr_mbti_image_url);
  React.useEffect(() => {
    if (!week_days_bld_sugr_mbti_image_url) return;
    if (!weekend_bld_sugr_mbti_image_url) return;
    if (duration) return;
    if (!weekday_image) return;
    if (!weekend_image) return;

    const images = [[weekday_image, setWeekdayData], [weekend_image, setWeekendData]];
    images.forEach(([image, setData]) => {
      const width = 360;
      const height = 240;

      const canvas = document.createElement('canvas');
      canvas.setAttribute('width', width + 'px');
      canvas.setAttribute('height', height + 'px');
      canvas.style.visibility = 'hidden';
      canvas.style.position = 'absolute';
      canvas.style.pointerEvents = 'none';
      const ctx = canvas.getContext('2d', { willReadFrequently: !duration });
      ctx.drawImage(image, 0, 0, width, height);
      const url = canvas.toDataURL('image/png');
      setData(() => ({ url, width, height }));
      URL.revokeObjectURL(url);
    });

  }, [data, duration, setWeekdayData, setWeekendData, week_days_bld_sugr_mbti_image_url, weekday_image, weekend_bld_sugr_mbti_image_url, weekend_image]);

  return (
    <Section
      {...ex('GlocosePattern', {
        ...props,
        caption: T('혈당패턴'),
        direction: DIRECTION_HORIZONTAL,
      })}
    >
      <PatternSummaryBox
        {...{
          caption: T('주중 대표패턴'),
          pattern: week_days_bld_sugr_mbti,
          description: (
            <div>
              {week_days_bld_sugr_mbti_content}
            </div>
          ),
          data: {
            ...data,
            dawn_pattern_info: week_days_dawn_pattern_info,
            morning_pattern_info: week_days_morning_pattern_info,
            lunch_pattern_info: week_days_lunch_pattern_info,
            evening_pattern_info: week_days_evening_pattern_info,
            search_dv: 2,
            search_key: 1,
            image: week_days_bld_sugr_mbti_image_url,
          },
        }}
      />
      <PatternSummaryBox
        {...{
          caption: T('주말 대표패턴'),
          pattern: weekend_bld_sugr_mbti,
          description: (
            <div>
              {weekend_bld_sugr_mbti_content}
            </div>
          ),
          data: {
            ...data,
            dawn_pattern_info: weekend_dawn_pattern_info,
            morning_pattern_info: weekend_morning_pattern_info,
            lunch_pattern_info: weekend_lunch_pattern_info,
            evening_pattern_info: weekend_evening_pattern_info,
            search_dv: 2,
            search_key: 2,
            image: weekend_bld_sugr_mbti_image_url,
          },
        }}
      />
    </Section>
  );
}

